import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Row, Col, ButtonToolbar, Button, FormGroup, FormControl, Modal } from 'react-bootstrap'
import { FileInput, ButtonData, ButtonProgress } from '.'
import { rest, utils } from '../../lib'
import { HOST } from '../../lib/constants'
import styled from 'styled-components'

const url = `${HOST}/sm/event/notice`
const Label = styled.div`
  font-size: 1.1rem;
`

class NoticeEditor extends React.PureComponent {
  constructor(...args) {
    super(...args)
    this.file = null
    this.state = {
      notice: this.props.notice,
      titleAlert: '',
      contentAlert: '',
      editable: this.props.editable,
      loading: false,
      progress: 0,
      error: '',
      show: this.props.show
    }
  }

  componentDidMount = () => this._isMounted = true
  componentWillUnmount = () => this._isMounted = false
  componentWillReceiveProps = props => {
    if (props.show !== this.state.show) {
      this.file = null
      this.setState({
        notice: props.notice,
        titleAlert: '',
        contentAlert: '',
        editable: props.editable,
        loading: false,
        progress: 0,
        error: '',
        show: props.show
      })
    }
  }

  docView = doc => window.open(HOST + doc)
  onFinish = () => this.props.onFinish(true)
  onCancel = () => this.props.onFinish(false)

  onFileSelect = file => this.file = file
  updateTitle = e => this.setState({
    notice: { ...this.state.notice, title: e.target.value },
    titleAlert: utils.utfByteLength(e.target.value) > 400 ? 'length is over limit(400)' : ''
  })
  updateContnet = e => this.setState({
    notice: { ...this.state.notice, content: e.target.value },
    contentAlert: utils.utfByteLength(e.target.value) > 4096 ? 'length is over limit(4096)' : ''
  })

  publish = () => {
    const { notice, loading } = this.state
    if (loading) return
    if (!notice.title) return this.setState({ titleAlert: 'title is required' })
    if (utils.utfByteLength(notice.title) > 400) return this.setState({ titleAlert: 'length is over limit(400)' })
    if (notice.content && utils.utfByteLength(notice.content) > 4096) return this.setState({ contentAlert: 'length is over limit(4096)' })

    rest.post(url+'/add', utils.json(notice)).then(res => {
      console.log(res)
      if (res.event) {
        console.log(this.file)
        if (this.file) {
          this.upload(res.event)
        } else {
          this.onFinish()
        }
      } else {
        this.onFinish()
      }
    })
  }

  upload = notice => {
    if (!notice.id) return this.onFinish()

    const param = { id : notice.id, name: this.file.name }
    console.log('upload param', param)
    this.setState({ loading: true, progress: 0, error: '' })
    rest.upload(url+'/upload', param, this.file, this.onProgress).then(res => {
      this.file = null
      console.log(res)
      if (res.status === 'success') {
        this._isMount && this.setState({ loading: false, progress: 0, error: '' })
        this.onFinish()
      } else {
        this._isMount && this.setState({ loading: false, progress: 0, error: 'Aborted' })
      }
    }).catch(e => {
      console.log(e)
      this._isMount && this.setState({ loading: false, progress: 0, error: 'Aborted' })
    })
  }

  onProgress = e => {
    const percent = parseInt((e.loaded / e.total * 100), 0)
    this._isMount && this.setState({ progress: percent >= 100 ? 0 : percent })
  }

  renderEdit = (title, content) => (
    <div>
      <FormGroup controlId='title' className={ cx({ 'has-warning': !!this.state.titleAlert }) }>
        <Label>Title</Label>
        <FormControl type='text' value={title || ''} onChange={this.updateTitle} autoComplete='off'/>
        <small className='form-message dark'>{this.state.titleAlert}</small>
      </FormGroup>
      <FormGroup controlId='content' className={ cx({ 'has-warning': !!this.state.contentAlert }) }>
        <Label>Content</Label>
        <FormControl componentClass='textarea' rows={10} value={content || ''} onChange={this.updateContnet}/>
        <small className='form-message dark'>{this.state.contentAlert}</small>
      </FormGroup>
      <FormGroup>
        <Label>Attachment</Label>
        <FileInput accept='*.pdf' onChange={this.onFileSelect}/>
      </FormGroup>
    </div>
  )

  renderView = (title, content, attachment) => (
    <div>
      <div className='font-size-15 m-b-1'>{title}</div>
      <div className='m-b-1' style={{ whiteSpace: 'pre-line' }}>{content}</div>
      {
        attachment && <ButtonData type='button' data={attachment} bsSize='sm' bsStyle='info' onClick={this.docView}>Attachment</ButtonData>
      }
    </div>
  )

  render() {
    const { notice, loading, progress, error, show } = this.state
    const { created, author, title, content, attachment } = notice
    const { editable } = this.props

    return (
      <Modal show={show} onHide={this.onCancel}>
        <Modal.Header closeButton><Modal.Title>Site News</Modal.Title></Modal.Header>
        <Modal.Body>
          <FormGroup>
            <Row>
              <Col md={6}>{created && `${created.substring(0, 10)} ${created.substring(11,16)}`}</Col>
              <Col md={6}>{author}</Col>
            </Row>
          </FormGroup>
          {
            editable ?  this.renderEdit(title, content) : this.renderView(title, content, attachment)
          }
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar style={{ float: 'right' }}>
            {
              editable &&
              <ButtonProgress bsSize='sm' bsStyle='info' className='btn-outline' loading={loading} progress={progress} error={error} onClick={this.publish}>Publish</ButtonProgress>
            }
            <Button bsSize='sm' bsStyle='danger' className='btn-outline' onClick={this.onCancel}>Close</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    )
  }
}

NoticeEditor.defaultProps = {
  notice: {},
  editable: true,
  show: false,
  onFinish: () => {},
}

NoticeEditor.propTypes = {
  notice: PropTypes.object,
  editable: PropTypes.bool,
  show: PropTypes.bool,
  onFinish: PropTypes.func,
}

export default NoticeEditor



// WEBPACK FOOTER //
// ./src/components/widgets/NoticeEditor.js